var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNfc = function SvgNfc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    rx: 15,
    fill: "#45B1FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#nfc_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.008 20.966V37.04a3.963 3.963 0 0 1-3.963 3.963h-8.541l-3.792-2.99V22.64l6.235 6.832a.858.858 0 0 0 1.332-1.076l-7.721-8.54a.837.837 0 0 0-.94-.223.854.854 0 0 0-.614.786v18.004a.838.838 0 0 0 .324.667l2.375 1.913H20.97a3.963 3.963 0 0 1-3.963-3.963V20.966a3.963 3.963 0 0 1 3.963-3.963h8.54l3.776 2.99v15.373l-6.218-6.833a.87.87 0 0 0-1.213-.137.839.839 0 0 0-.12 1.196.172.172 0 0 0 0 .085l7.704 8.541a.888.888 0 0 0 .94.222.855.855 0 0 0 .547-.802V19.565a.87.87 0 0 0-.325-.666l-2.22-1.896h4.748a3.963 3.963 0 0 1 3.963 3.963h-.085Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "nfc_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(17 17)",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgNfc;